import { Grid } from "@material-ui/core"
import MemberPhoto from "../Common/MemberPhoto"
import MemberDetails from "./MemberDetails"
import React from "react"

export const TeamMember = ({ member }) => (
  <Grid container alignItems={"flex-start"} justify={"center"} spacing={4}>
    <Grid item xs={12} md={3}>
      <MemberPhoto photoName={member.photoName} />
    </Grid>
    <Grid item xs={12} md={8}>
      <MemberDetails
        name={member.name}
        about={member.about}
        socialHandles={member.social}
      />
    </Grid>
  </Grid>
)
